import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughTagsProps = {
  node: ConversationFlowAuditLogEntry<
    | 'EMAIL_TAG_NODE_VISITED'
    | 'TELEPHONY_TAG_NODE_VISITED'
    | 'MESSENGER_TAG_NODE_VISITED'
  >;
};

export function RoutedThroughTags({
  node,
}: RoutedThroughTagsProps): JSX.Element {
  return (
    <>
      Tags · Tagged with <strong>{node.tag_ids.join(', ')}</strong>
    </>
  );
}
